import { render, staticRenderFns } from "./add_quarantine.vue?vue&type=template&id=27136b12&"
import script from "./add_quarantine.vue?vue&type=script&lang=js&"
export * from "./add_quarantine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports